import React, { useState, useEffect, useMemo } from 'react';
import { db } from './firebase';
import { collection, query, onSnapshot, doc, getDoc, setDoc, deleteDoc, serverTimestamp, getDocs, writeBatch, orderBy, updateDoc, addDoc, Timestamp } from 'firebase/firestore';
import toast, { Toaster } from 'react-hot-toast';
import Modal from 'react-modal';
import { FaWhatsapp, FaPlus, FaTrash, FaUndo, FaTrashAlt, FaClipboardList } from 'react-icons/fa';

// 🔥 ETAPAS KOKIMIKO 🔥
const STAGES = [
    { id: 'nueva_solicitud', label: 'Solicitud' },
    { id: 'presupuesto_enviado', label: 'Cotizado' },
    { id: 'abonado', label: 'Abonado' },
    { id: 'confirmado', label: 'Confirmado' }
];

const PipelineTracker = ({ currentStatus, onStatusChange, editable = false }) => {
    const currentIndex = STAGES.findIndex(stage => stage.id === currentStatus);
    return (
        <div className="flex items-center justify-between w-full mt-2">
            {STAGES.map((stage, index) => {
                const isCompleted = index < currentIndex;
                const isCurrent = index === currentIndex;
                
                let bgColor = 'bg-gray-200 text-gray-400';
                if (isCompleted) bgColor = 'bg-kokimiko-verde text-white shadow-sm';
                if (isCurrent) bgColor = 'bg-kokimiko-teal text-white shadow-md ring-2 ring-kokimiko-teal/50';

                const node = (
                    <div className="flex flex-col items-center text-center px-1 relative z-10 group">
                        <div className={`w-6 h-6 rounded-full flex items-center justify-center font-bold text-[10px] transition-all ${bgColor} ${editable ? 'cursor-pointer hover:scale-110' : ''}`}>
                            {index + 1}
                        </div>
                        <p className={`mt-1 text-[9px] font-black uppercase tracking-wider ${isCurrent ? 'text-kokimiko-teal' : 'text-gray-400'}`}>
                            {stage.label}
                        </p>
                    </div>
                );
                return (
                    <React.Fragment key={stage.id}>
                        {editable ? <button type="button" onClick={() => onStatusChange(stage.id)} className="focus:outline-none">{node}</button> : node}
                        {index < STAGES.length - 1 && <div className={`flex-1 h-1 rounded-full mx-1 ${index < currentIndex ? 'bg-kokimiko-verde' : 'bg-gray-200'}`}></div>}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

// MODAL PARA NUEVA SOLICITUD MANUAL
const NuevaSolicitudModal = ({ onClose, onSave }) => {
    const [nombre, setNombre] = useState('');
    const [telefono, setTelefono] = useState('');
    const [tipo, setTipo] = useState('Fiesta Infantil');
    const [notas, setNotas] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!nombre) return toast.error("El nombre es obligatorio");
        onSave({ nombre, telefono, tipo, notas });
    };

    return (
        <form onSubmit={handleSubmit} className="bg-white p-6 rounded-[2rem] shadow-2xl max-w-md w-full border border-gray-100">
            <h3 className="text-xl font-black text-kokimiko-texto mb-5 uppercase tracking-widest flex items-center gap-2">
                <FaPlus className="text-kokimiko-teal" /> Nueva Solicitud
            </h3>
            <div className="space-y-4">
                <div>
                    <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1">Nombre de la Familia</label>
                    <input type="text" value={nombre} onChange={e => setNombre(e.target.value)} required placeholder="Ej: Familia Pérez" className="w-full p-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-kokimiko-teal focus:outline-none text-sm" />
                </div>
                <div>
                    <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1">Teléfono (WhatsApp)</label>
                    <input type="text" value={telefono} onChange={e => setTelefono(e.target.value)} placeholder="Ej: 600 123 456" className="w-full p-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-kokimiko-teal focus:outline-none text-sm" />
                </div>
                <div>
                    <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1">Tipo de Evento</label>
                    <select value={tipo} onChange={e => setTipo(e.target.value)} className="w-full p-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-kokimiko-teal focus:outline-none text-sm font-bold text-kokimiko-texto">
                        <option value="Fiesta Infantil">Fiesta Infantil</option>
                        <option value="Taller">Taller / Actividad</option>
                        <option value="Alquiler Sala">Alquiler de Sala</option>
                    </select>
                </div>
                <div>
                    <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1">Notas Iniciales</label>
                    <textarea value={notas} onChange={e => setNotas(e.target.value)} placeholder="Ej: Quieren temática de dinosaurios..." className="w-full p-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-kokimiko-teal focus:outline-none text-sm resize-none h-20" />
                </div>
            </div>
            <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-100">
                <button type="button" onClick={onClose} className="px-5 py-2 bg-gray-100 text-kokimiko-texto font-bold rounded-xl text-sm uppercase tracking-widest hover:bg-gray-200">Cancelar</button>
                <button type="submit" className="px-5 py-2 bg-kokimiko-teal text-white font-black rounded-xl text-sm uppercase tracking-widest hover:opacity-80 shadow-md">Guardar</button>
            </div>
        </form>
    );
};

const BitacoraModal = ({ seguimiento, onClose, coleccionOrigen }) => {
    const [bitacora, setBitacora] = useState([]);
    const [cargandoBitacora, setCargandoBitacora] = useState(true);
    const [nuevaNota, setNuevaNota] = useState('');

    useEffect(() => {
        const bitacoraRef = collection(db, coleccionOrigen, seguimiento.id, 'bitacora');
        const q = query(bitacoraRef, orderBy('fecha', 'desc'));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            setBitacora(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            setCargandoBitacora(false);
        });
        return () => unsubscribe();
    }, [seguimiento.id, coleccionOrigen]);

    const handleAgregarNota = async () => {
        if (nuevaNota.trim() === '') return toast.error('La nota no puede estar vacía.');
        const bitacoraRef = collection(db, coleccionOrigen, seguimiento.id, 'bitacora');
        const seguimientoRef = doc(db, coleccionOrigen, seguimiento.id);
        const fechaActual = Timestamp.now();

        try {
            await addDoc(bitacoraRef, { texto: nuevaNota, fecha: fechaActual });
            await updateDoc(seguimientoRef, { lastInteractionDate: fechaActual });
            setNuevaNota('');
            toast.success('Nota añadida al expediente.');
        } catch (error) {
            toast.error('No se pudo guardar la nota.');
        }
    };
    
    return (
        <div className="bg-white p-8 rounded-[2.5rem] shadow-2xl max-w-2xl w-full max-h-[80vh] flex flex-col border border-gray-100">
            <h3 className="text-2xl font-black text-kokimiko-texto mb-2 uppercase tracking-tighter flex items-center gap-2">
                <FaClipboardList className="text-kokimiko-teal" /> Expediente: {seguimiento.clienteName}
            </h3>
            <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-6 border-b pb-4">{seguimiento.tipoEvento || 'Fiesta Infantil'}</p>
            
            <div className="mb-6">
                <textarea 
                    value={nuevaNota}
                    onChange={(e) => setNuevaNota(e.target.value)}
                    placeholder="Escribe aquí los detalles de la llamada o acuerdo..."
                    className="w-full p-4 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-kokimiko-teal focus:outline-none text-sm resize-none"
                    rows="3"
                ></textarea>
                <div className="flex justify-end mt-2">
                    <button onClick={handleAgregarNota} className="px-6 py-2 bg-kokimiko-teal text-white font-black rounded-xl hover:opacity-80 shadow-md text-sm uppercase tracking-widest">Guardar Nota</button>
                </div>
            </div>
            
            <div className="flex-grow overflow-y-auto custom-scrollbar pr-2 space-y-3">
                {cargandoBitacora ? <p className="text-center text-gray-400 font-bold animate-pulse">Cargando expediente...</p> : 
                    bitacora.length > 0 ? (
                        bitacora.map(nota => (
                            <div key={nota.id} className="bg-gray-50 p-4 rounded-2xl border border-gray-100">
                                <p className="text-sm text-kokimiko-texto font-medium whitespace-pre-wrap">{nota.texto}</p>
                                <p className="text-[10px] font-black text-gray-400 mt-2 uppercase tracking-widest">{nota.fecha?.toDate().toLocaleString('es-ES')}</p>
                            </div>
                        ))
                    ) : <p className="text-center text-gray-400 font-bold italic mt-10">No hay notas registradas todavía.</p>
                }
            </div>
            <button onClick={onClose} className="mt-6 px-6 py-3 bg-kokimiko-texto text-white font-black rounded-xl hover:opacity-90 w-full uppercase tracking-widest shadow-lg">Cerrar Expediente</button>
        </div>
    );
};

function SeguimientoView() {
    const [vistaActual, setVistaActual] = useState('nuevas');
    const [seguimientos, setSeguimientos] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [terminoBusqueda, setTerminoBusqueda] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [seguimientoSeleccionado, setSeguimientoSeleccionado] = useState(null);
    const [isManualModalOpen, setIsManualModalOpen] = useState(false);

    useEffect(() => {
        setCargando(true);
        let coleccion = 'seguimientosEnProceso';
        if (vistaActual === 'historial') coleccion = 'seguimientosCulminados';

        const q = query(collection(db, coleccion), orderBy('createdAt', 'desc'));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            let data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            
            if (vistaActual === 'nuevas') data = data.filter(s => s.pipelineStatus === 'nueva_solicitud' || !s.pipelineStatus);
            if (vistaActual === 'presupuestos') data = data.filter(s => s.pipelineStatus === 'presupuesto_enviado');
            if (vistaActual === 'confirmados') data = data.filter(s => s.pipelineStatus === 'abonado' || s.pipelineStatus === 'confirmado');
            
            setSeguimientos(data);
            setCargando(false);
        });
        return () => unsubscribe();
    }, [vistaActual]);

    const handleSaveManual = async (datos) => {
        const toastId = toast.loading('Creando solicitud...');
        try {
            await addDoc(collection(db, 'seguimientosEnProceso'), {
                clienteName: datos.nombre,
                telefono: datos.telefono,
                tipoEvento: datos.tipo,
                pipelineStatus: 'nueva_solicitud',
                createdAt: serverTimestamp(),
                lastInteractionDate: serverTimestamp()
            });
            toast.success('Solicitud guardada', { id: toastId });
            setIsManualModalOpen(false);
        } catch (error) {
            toast.error('Error al guardar', { id: toastId });
        }
    };

    const moveDocument = async (seguimientoId, origen, destino) => {
        const origenRef = doc(db, origen, seguimientoId);
        const docSnap = await getDoc(origenRef);
        if (docSnap.exists()) {
            await setDoc(doc(db, destino, seguimientoId), docSnap.data());
            await deleteDoc(origenRef);
            return true;
        }
        return false;
    };

    const handleStatusChange = async (seguimiento, nuevoStatus) => {
        if (vistaActual === 'historial') return;
        
        if (nuevoStatus === 'confirmado') {
            if (window.confirm(`¿Aprobar y pasar "${seguimiento.clienteName}" al panel de Fiestas y Talleres definitivos?`)) {
                const crearProyectoPromise = async () => {
                    await addDoc(collection(db, "proyectosEnTransito"), {
                        nombreProyecto: `${seguimiento.tipoEvento || 'Evento'} - ${seguimiento.clienteName}`,
                        nombreCliente: seguimiento.clienteName,
                        telefono: seguimiento.telefono || '',
                        estado: 'Aprobado',
                        fechaCreacion: serverTimestamp(),
                    });
                    await moveDocument(seguimiento.id, 'seguimientosEnProceso', 'seguimientosCulminados');
                };
                await toast.promise(crearProyectoPromise(), {
                    loading: 'Procesando...',
                    success: '¡Evento confirmado y enviado a producción!',
                    error: 'Error al confirmar.'
                });
            }
        } else {
            const docRef = doc(db, 'seguimientosEnProceso', seguimiento.id);
            await toast.promise(updateDoc(docRef, { pipelineStatus: nuevoStatus }), { 
                loading: 'Actualizando...', success: '¡Estado actualizado!', error: 'Error.'
            });
        }
    };
    
    const handleDelete = async (seguimientoId) => {
         if (window.confirm("¿Cancelar solicitud y mover al historial?")) {
            await toast.promise(moveDocument(seguimientoId, 'seguimientosEnProceso', 'seguimientosPapelera'), { 
                loading: 'Cancelando...', success: 'Solicitud cancelada.', error: 'Error al cancelar.'
            });
        }
    };

    const seguimientosFiltrados = useMemo(() => {
        if (!terminoBusqueda) return seguimientos;
        const lowerCaseSearch = terminoBusqueda.toLowerCase();
        return seguimientos.filter(s => 
            (s.clienteName || '').toLowerCase().includes(lowerCaseSearch) ||
            (s.telefono || '').toLowerCase().includes(lowerCaseSearch)
        );
    }, [seguimientos, terminoBusqueda]);
    
    const openModalConSeguimiento = (seguimiento) => {
        setSeguimientoSeleccionado(seguimiento);
        setModalOpen(true);
    };

    const TabButton = ({ id, label }) => (
        <button 
            onClick={() => setVistaActual(id)} 
            className={`py-3 px-6 font-black text-xs uppercase tracking-widest transition-all rounded-t-2xl ${vistaActual === id ? 'bg-white text-kokimiko-texto border-t-4 border-kokimiko-teal shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)]' : 'bg-gray-100 text-gray-400 hover:bg-gray-200 hover:text-gray-600'}`}
        >
            {label}
        </button>
    );

    return (
        <div className="h-full flex flex-col p-4 md:p-8 bg-kokimiko-fondo/30 font-sans">
            <Toaster position="top-right" />
            
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 bg-white p-6 rounded-[2rem] shadow-sm border border-gray-100 gap-4">
                <h1 className="text-2xl font-black text-kokimiko-texto uppercase tracking-widest flex items-center gap-3">
                    Eventos
                </h1>
                <button onClick={() => setIsManualModalOpen(true)} className="px-6 py-3 bg-kokimiko-teal text-white font-black rounded-xl hover:opacity-80 shadow-md uppercase tracking-widest text-xs flex items-center gap-2 w-full md:w-auto justify-center">
                    <FaPlus /> Nueva Solicitud Manual
                </button>
            </div>

            <div className="flex overflow-x-auto custom-scrollbar border-b border-gray-200">
                <TabButton id="nuevas" label="Nuevas Solicitudes" />
                <TabButton id="presupuestos" label="Presupuestos Enviados" />
                <TabButton id="confirmados" label="Abonados / Confirmados" />
                <TabButton id="historial" label="Historial" />
            </div>
            
            <div className="bg-white p-6 rounded-b-[2rem] rounded-tr-[2rem] shadow-sm border border-gray-100 flex-grow flex flex-col min-h-0">
                <div className="mb-6 relative">
                    <input
                        type="text"
                        placeholder="Buscar familia o teléfono..."
                        value={terminoBusqueda}
                        onChange={(e) => setTerminoBusqueda(e.target.value)}
                        className="w-full p-4 pl-12 bg-gray-50 border border-gray-200 rounded-2xl shadow-sm focus:outline-none focus:ring-2 focus:ring-kokimiko-teal text-sm font-bold text-kokimiko-texto"
                    />
                    <span className="absolute left-4 top-4 text-gray-400 text-lg">🔍</span>
                </div>
                
                <div className="flex-grow overflow-y-auto custom-scrollbar pr-2">
                    {cargando ? ( <div className="text-center py-12 text-gray-400 font-bold animate-pulse">Cargando radar...</div> ) : (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {seguimientosFiltrados.length > 0 ? (
                                seguimientosFiltrados.map(seguimiento => (
                                    <div key={seguimiento.id} className="bg-white p-6 border-2 border-gray-100 rounded-[2rem] shadow-sm hover:shadow-lg hover:border-kokimiko-teal/30 cursor-pointer flex flex-col transition-all group relative overflow-hidden" onClick={() => openModalConSeguimiento(seguimiento)}>
                                        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-kokimiko-teal to-kokimiko-verde opacity-0 group-hover:opacity-100 transition-opacity"></div>
                                        
                                        <div className="flex justify-between items-start mb-2">
                                            <div className="w-full">
                                                <h3 className="font-black text-lg text-kokimiko-texto truncate mb-1">{seguimiento.clienteName}</h3>
                                                <div className="flex justify-between items-center w-full">
                                                    <span className="text-[10px] font-black text-white bg-kokimiko-texto px-3 py-1 rounded-full uppercase tracking-widest">{seguimiento.tipoEvento || 'Fiesta'}</span>
                                                    
                                                    {vistaActual !== 'historial' && (
                                                        <div className="flex gap-2">
                                                            {seguimiento.telefono && (
                                                                <a href={`https://wa.me/${seguimiento.telefono}`} onClick={(e) => e.stopPropagation()} target="_blank" rel="noreferrer" className="p-2 bg-green-100 text-green-600 rounded-xl hover:bg-green-50 hover:text-white transition-colors" title="Escribir por WhatsApp">
                                                                    <FaWhatsapp size={16} />
                                                                </a>
                                                            )}
                                                            <button onClick={(e) => { e.stopPropagation(); handleDelete(seguimiento.id); }} className="p-2 bg-red-50 text-kokimiko-naranja rounded-xl hover:bg-kokimiko-naranja hover:text-white transition-colors" title="Cancelar Solicitud">
                                                                <FaTrashAlt size={16} />
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        
                                        {vistaActual !== 'historial' && (
                                            <div className="mt-auto pt-4 border-t border-gray-50 flex items-center">
                                                <PipelineTracker 
                                                    currentStatus={seguimiento.pipelineStatus || 'nueva_solicitud'} 
                                                    onStatusChange={(nuevoStatus) => handleStatusChange(seguimiento, nuevoStatus)}
                                                    editable={true}
                                                />
                                            </div>
                                        )}
                                    </div>
                                ))
                            ) : (
                                <div className="text-center py-20 text-gray-400 font-bold col-span-full border-2 border-dashed border-gray-200 rounded-[2rem]">
                                    No hay familias en esta etapa del embudo.
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
            
            <Modal isOpen={isManualModalOpen} onRequestClose={() => setIsManualModalOpen(false)} style={{ overlay: { backgroundColor: 'rgba(35,37,89,0.75)', zIndex: 1000 }, content: { background: 'none', border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }}} ariaHideApp={false}>
                <NuevaSolicitudModal onClose={() => setIsManualModalOpen(false)} onSave={handleSaveManual} />
            </Modal>

            {modalOpen && seguimientoSeleccionado && (
                <Modal isOpen={modalOpen} onRequestClose={() => setModalOpen(false)} style={{ overlay: { backgroundColor: 'rgba(35,37,89,0.75)', zIndex: 1000 }, content: { background: 'none', border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}} ariaHideApp={false}>
                    <BitacoraModal seguimiento={seguimientoSeleccionado} onClose={() => setModalOpen(false)} coleccionOrigen={vistaActual === 'historial' ? 'seguimientosCulminados' : 'seguimientosEnProceso'} />
                </Modal>
            )}
        </div>
    );
}

export default SeguimientoView;